import { render, staticRenderFns } from "./btj.vue?vue&type=template&id=33b51b01&scoped=true"
import script from "./btj.vue?vue&type=script&lang=js"
export * from "./btj.vue?vue&type=script&lang=js"
import style0 from "./btj.vue?vue&type=style&index=0&id=33b51b01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b51b01",
  null
  
)

export default component.exports